import { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { Link } from "react-router-dom";
import { BookImage, ChevronLeft, ChevronRight, SearchCheck, ShoppingCart } from "lucide-react";
import Cookies from "universal-cookie";

export default function Ventas() {
   const cookies = new Cookies();
   // const [imagenes, setImagenes] = useState([]);
   const [obras, setObras] = useState([]);
   const [filtrado, setFiltrado] = useState([]);
   const [tasks, setTasks] = useState([]);
   // eslint-disable-next-line
   const [change, setChange] = useState(false);
   const [selected, setSelected] = useState("");
   const [loading, setLoading] = useState(true);
   const [currentImageByObra, setCurrentImageByObra] = useState({});

   const fetchTabla = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 2)
         .gt("orden", 1)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };

   const fetchObras = async () => {
      setLoading(true);
      const { error, data } = await supabase
         .from("obras")
         .select(
            `
        id,titulo,descripcion,medidas,precio,filtros,
        imagenes(texto,orden,imagen_url)
        `
         )
         .eq("estado", 2)
         //.eq("imagenes.orden", 1)
         .neq("filtros","[\"6\"]") // Exclude obras with filtro "6"
         .gt("id", 1)
         // .order("titulo", { ascending: true });

      if (error) {
         console.error("Error reading obra: ", error.message);
         setLoading(false);
         return;
      }
      const ordenado = data.sort((a, b) => {
      const numA = parseInt(a.titulo.replace(/\D/g, ''), 10);
      const numB = parseInt(b.titulo.replace(/\D/g, ''), 10);
      return numA - numB;
      });
      setObras(ordenado);
      setFiltrado(ordenado);
      setLoading(false);
   };

   const grabarCarrito = async (id) => {
      // Cambio estado de la obra a pedido
      const { error } = await supabase
         .from("obras")
         .update({
            estado: 23,
         })
         .eq("id", id);
      if (error) {
         console.error("Error updating obra: ", error.message);
         return;
      }
      console.log("grabarCarrito: ", id);
      // Get current cart from cookies
      let cart = cookies.get("obra") || [];
      // If not array, make it array
      if (!Array.isArray(cart)) cart = [];
      // Add the new id if not already in cart
      if (!cart.includes(id)) cart.push(id);
      // Save back to cookies
      cookies.set("obra", cart, { path: "/" });
      // Dispatch custom event to notify Navbar
      window.dispatchEvent(new Event("cartUpdated"));
      setChange(!change);
   };

   useEffect(() => {
      fetchTabla();
      fetchObras();
   }, [change]);

   const filterObras = (obrasList, selectedValue) => {
      const filtrosArr = [];
      if (selectedValue) {
         for (let i = 0; i < obrasList.length; i++) {
            console.log("obrasList[i].filtros: ", obrasList[i].filtros);
            if (obrasList[i].filtros.includes('"' + selectedValue + '"')) {
               filtrosArr.push(obrasList[i]);
            }
         }
         return filtrosArr;
      } else {
         return obrasList;
      }
   };

   const handleChange = (e) => {
      const value = e.target.value;
      setSelected(value);
      setFiltrado(filterObras(obras, value));
   };

   useEffect(() => {
      setFiltrado(filterObras(obras, selected));
   }, [obras, selected]);

   const getSortedImages = (rec) => {
      const imagenes = rec?.imagenes || [];
      return [...imagenes].sort((a, b) => (a?.orden ?? 9999) - (b?.orden ?? 9999));
   };

   const goToImage = (obraId, imageIndex) => {
      setCurrentImageByObra((prev) => ({
         ...prev,
         [obraId]: imageIndex,
      }));
   };

   const goToPrevImage = (obraId, total) => {
      setCurrentImageByObra((prev) => {
         const current = prev[obraId] ?? 0;
         return {
            ...prev,
            [obraId]: current === 0 ? total - 1 : current - 1,
         };
      });
   };

   const goToNextImage = (obraId, total) => {
      setCurrentImageByObra((prev) => {
         const current = prev[obraId] ?? 0;
         return {
            ...prev,
            [obraId]: current === total - 1 ? 0 : current + 1,
         };
      });
   };

   console.log("filtrado: ", filtrado);

   return (
      <div className="min-h-screen bg-[#FAFAF8]">
         {/* Page Header */}
         <div className="border-b border-[#EDE9E4] py-16 px-6 text-center">
            <p className="text-[0.68rem] uppercase tracking-[0.25em] text-[#9B6D3F] mb-4">Colección</p>
            <h1
               className="text-5xl md:text-6xl font-medium text-[#1A1A1A]"
               style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
            >
               Obras Contemporáneas
            </h1>
            <div className="w-10 h-[1px] bg-[#9B6D3F] mx-auto mt-7" />
         </div>

         {/* Gallery */}
         <div className="max-w-7xl mx-auto px-6 py-16">
            {loading ? (
               <div className="flex justify-center items-center h-64">
                  <div className="w-8 h-8 border-2 border-[#9B6D3F] border-t-transparent rounded-full animate-spin" />
               </div>
            ) : filtrado.length === 0 ? (
               <div className="text-center py-24">
                  <p className="text-[0.78rem] uppercase tracking-[0.15em] text-[#7A7570]">
                     No se encontraron obras
                  </p>
                  {selected && (
                     <button
                        onClick={() => { setSelected(""); setFiltrado(obras); }}
                        className="mt-6 text-[0.72rem] uppercase tracking-[0.12em] text-[#9B6D3F] border-b border-[#9B6D3F] pb-0.5 hover:text-[#6B4A2A] transition-colors"
                     >
                        Ver todas
                     </button>
                  )}
               </div>
            ) : (
               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
                  {filtrado.map((rec) => (
                     <div key={rec.id} className="group relative">
                        {(() => {
                           const fotos = getSortedImages(rec);
                           const totalFotos = fotos.length;
                           const currentIndex = currentImageByObra[rec.id] ?? 0;
                           const safeIndex = currentIndex >= totalFotos ? 0 : currentIndex;
                           const activeImage = fotos[safeIndex]?.imagen_url;

                           return (
                              <>
                        {/* Image container */}
                        <div className="relative overflow-hidden aspect-[3/4] bg-[#F5F0EB] mb-4">
                           {activeImage ? (
                              <img
                                 src={activeImage}
                                 alt={rec.titulo}
                                 className="w-full h-full object-contain"
                              />
                           ) : (
                              <div className="w-full h-full flex items-center justify-center text-[#7A7570]">
                                 <BookImage className="w-6 h-6" />
                              </div>
                           )}

                           {totalFotos > 1 && (
                              <>
                                 <button
                                    type="button"
                                    onClick={(e) => {
                                       e.stopPropagation();
                                       goToPrevImage(rec.id, totalFotos);
                                    }}
                                    className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/80 text-[#1A1A1A] hover:bg-white transition-colors flex items-center justify-center"
                                    aria-label="Imagen anterior"
                                 >
                                    <ChevronLeft className="w-4 h-4" />
                                 </button>

                                 <button
                                    type="button"
                                    onClick={(e) => {
                                       e.stopPropagation();
                                       goToNextImage(rec.id, totalFotos);
                                    }}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/80 text-[#1A1A1A] hover:bg-white transition-colors flex items-center justify-center"
                                    aria-label="Imagen siguiente"
                                 >
                                    <ChevronRight className="w-4 h-4" />
                                 </button>

                                 <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1.5">
                                    {fotos.map((_, idx) => (
                                       <button
                                          key={`${rec.id}-dot-${idx}`}
                                          type="button"
                                          onClick={(e) => {
                                             e.stopPropagation();
                                             goToImage(rec.id, idx);
                                          }}
                                          className={`h-1.5 w-1.5 rounded-full transition-all ${
                                             idx === safeIndex ? "bg-white w-4" : "bg-white/60"
                                          }`}
                                          aria-label={`Ver imagen ${idx + 1}`}
                                       />
                                    ))}
                                 </div>
                              </>
                           )}
                        </div>
                              </>
                           );
                        })()}

                        {/* Info */}
                        <h3
                           className="text-xl font-medium text-[#1A1A1A] mb-1"
                        >
                           {rec.titulo}
                        </h3>
                        <div className="flex gap-3 justify-between">
                        <p>
                            Medidas : {rec.medidas}
                        </p>
                        <Link
                           to="/obrasdet"
                           state={{
                              cod_obra: rec.id,
                           }}
                           
                        >                           
                           <SearchCheck className="w-4 h-4 text-[#9B6D3F]" />
                        </Link>
                        
                        </div>
                        <p className="text-[0.78rem] text-[#9B6D3F] mb-4">u$s {rec.precio}</p>

                        {/* Actions */}
                        <div className="flex gap-3">
                           <button
                              className="flex-1 text-[0.7rem] uppercase tracking-[0.12em] py-2.5 bg-[#9B6D3F] text-white hover:bg-[#6B4A2A] transition-colors duration-300 flex items-center justify-center gap-1.5"
                              onClick={() => grabarCarrito(rec.id)}
                           >
                              <ShoppingCart className="w-3.5 h-3.5" />
                              Reservar
                           </button>
                        </div>
                     </div>
                  ))}
               </div>
            )}
         </div>
      </div>
   );
}